import { Routes, Route } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import Sidebar from '@/components/layout/Sidebar/Sidebar';
import Navbar from '@/components/layout/Navbar/Navbar';
import Toast from '@/components/ui/Toast/Toast';
import UploadModal from '@/components/ui/UploadModal/UploadModal';
import ClipSelectionBar from '@/components/ui/ClipSelectionBar/ClipSelectionBar';
import CreateSectionModal from '@/components/ui/CreateSectionModal/CreateSectionModal';
import AssignSectionModal from '@/components/ui/AssignSectionModal/AssignSectionModal';
import ContentEnrichmentModal from '@/components/ui/ContentEnrichmentModal/ContentEnrichmentModal';
import MediaIntelligencePage from '@/pages/MediaIntelligencePage';
import DocumentIntelligencePage from '@/pages/DocumentIntelligencePage';
import LoginPage from '@/pages/LoginPage';
import SectionViewAllPage from '@/pages/SectionViewAllPage';
import styles from './App.module.css';

function HomePage() {
  const mode = useAppSelector((s) => s.ui.mode);
  const uploadModalOpen = useAppSelector((s) => s.ui.uploadModalOpen);
  const createModalOpen = useAppSelector((s) => s.sections.createModalOpen);
  const assignModalAssetId = useAppSelector((s) => s.sections.assignModalAssetId);
  const contentEnrichmentOpen = useAppSelector((s) => s.ui.contentEnrichmentOpen);
  return (
    <div className={styles.shell}>
      <Sidebar activeItem={mode === 'docs' ? 'projects' : 'library'} />
      <div className={styles.main}>
        <Navbar />
        {mode === 'media' ? <MediaIntelligencePage /> : <DocumentIntelligencePage />}
      </div>
      <Toast />
      <ClipSelectionBar />
      {uploadModalOpen && <UploadModal />}
      {createModalOpen && <CreateSectionModal />}
      {assignModalAssetId && <AssignSectionModal />}
      {contentEnrichmentOpen && <ContentEnrichmentModal />}
    </div>
  );
}

function SectionPage() {
  const uploadModalOpen = useAppSelector((s) => s.ui.uploadModalOpen);
  const createModalOpen = useAppSelector((s) => s.sections.createModalOpen);
  const assignModalAssetId = useAppSelector((s) => s.sections.assignModalAssetId);
  const contentEnrichmentOpen = useAppSelector((s) => s.ui.contentEnrichmentOpen);
  return (
    <div className={styles.shell}>
      <Sidebar activeItem="library" />
      <div className={styles.main}>
        <Navbar />
        <SectionViewAllPage />
      </div>
      <Toast />
      <ClipSelectionBar />
      {uploadModalOpen && <UploadModal />}
      {createModalOpen && <CreateSectionModal />}
      {assignModalAssetId && <AssignSectionModal />}
      {contentEnrichmentOpen && <ContentEnrichmentModal />}
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signin" element={<LoginPage />} />
      <Route path="/section/:sectionId" element={<SectionPage />} />
    </Routes>
  );
}
